import {
  Component,
  OnInit,
  signal,
  computed,
  WritableSignal,
  Signal,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from './core/providers/services/authentication.service';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr-CA';
import localeDe from '@angular/common/locales/de';
import localeJp from '@angular/common/locales/ja';
import localeEs from '@angular/common/locales/es';
import localeIt from '@angular/common/locales/it';
import { DefaultsService, LocaleService } from './core/providers';
import { MaintenanceModeService } from './maintenance-mode/maintenance-mode.service';
import { ClientBrandingService } from './client-branding/client-branding.service';
import { DialogService } from './core/dialogs/dialog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  languages: string[];
  readonly translationsLoaded: WritableSignal<boolean> = signal(false);
  readonly isAuthenticated: WritableSignal<boolean> = signal(false);
  readonly isLoaded: Signal<boolean> = computed(() => {
    return (
      this.translationsLoaded() &&
      this.isAuthenticated() &&
      this.clientBrandingService.isLoaded()
    );
  });
  constructor(
    public authenticationService: AuthenticationService,
    public translateService: TranslateService,
    public localeService: LocaleService,
    public defaultsService: DefaultsService,
    private maintenanceModeService: MaintenanceModeService, // self initialized after auth completes
    private clientBrandingService: ClientBrandingService, // self initialized after auth completes,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.translationInit();
    // implicit flow requires that 'handleauthentication' is triggered upon load, pkce manages callback in the
    // callback component directly
    if (!environment.isPkceFlowMode) {
      this.authenticationService.handleAuthentication(this.defaultsService);
    }
  }

  translationInit() {
    // Add supported languages (besides en-US)
    registerLocaleData(localeFr, 'fr-CA');
    registerLocaleData(localeDe, 'de-DE');
    registerLocaleData(localeJp, 'ja-JP');
    registerLocaleData(localeJp, 'en-GB');
    registerLocaleData(localeEs, 'es-ES');
    registerLocaleData(localeIt, 'it-IT');
    this.languages = [
      'en-US',
      'fr-CA',
      'de-DE',
      'ja-JP',
      'en-GB',
      'es-ES',
      'it-IT',
    ];
    this.translateService.addLangs(this.languages);

    this.authenticationService.Authenticated.subscribe((isAuth) => {
      if (isAuth) {
        this.isAuthenticated.set(true);
        this.insertHeap();
        // getBrowserCultureLang() returns BCP-47 (e.g. 'es-ES'); getBrowserLang() returns 2 chars (e.g. 'es').
        const cultureLang = this.translateService.getBrowserCultureLang();
        let browserLang =
          cultureLang && this.languages.includes(cultureLang)
            ? cultureLang
            : 'en-US';
        const gotLang =
          this.authenticationService &&
          this.authenticationService.userInfoView &&
          this.authenticationService.userInfoView.SelectedClient &&
          this.authenticationService.userInfoView.SelectedClient.Lang;
        /*        console.log(
          'app.component userInfoView ',
          this.authenticationService.userInfoView,
          '\nlocalService.getLocale()',
          this.localeService.getLocale(),
          '\nbrowserLang',
          browserLang
        );*/
        const actualLang = gotLang
          ? this.authenticationService.userInfoView.SelectedClient.Lang
          : this.localeService.getLocale() || browserLang;
        this.localeService.setLocale(actualLang.toString());
      }
    });

    this.localeService.observableLocale.subscribe((lang) => {
      if (lang && lang !== this.translateService.currentLang) {
        this.translateService.use(lang).subscribe((r) => {
          this.translationsLoaded.set(true);
        });
      }
    });
  }

  insertHeap = () => {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.text = `
          window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};
          var r=document.createElement("script");
          r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";
          var a=document.getElementsByTagName("script")[0];
          a.parentNode.insertBefore(r,a);
          for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};
          try {
              heap.load("${environment.heapId}");
              heap.identify("${this.authenticationService.userInfoView.UserId}");
              heap.addUserProperties({
                  RdoIdentityUserId: "${this.authenticationService.tokenInfo.AccessTokenDecoded['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']}",
                  RdoUserId: "${this.authenticationService.userInfoView.UserId}",
                  RdoClientId: "${this.authenticationService.userInfoView.SelectedClient.ClientID}",
                  RdoClientCode: "${this.authenticationService.userInfoView.SelectedClient.ClientCode}"
              });
          } catch (e) {
              console.error(e.message);
          }`;
    document.getElementsByTagName('head')[0].appendChild(s);
  };
}
